export const CAMPANHAS_PAGE = () => "/campanhas";
export const CAMPANHA_NEW_PAGE = () => "/campanhas/nova";
export const CAMPANHA_PAGE = (id = ":id") => `/campanhas/${id}`;
export const CAMPANHA_EDIT_PAGE = (id = ":id") => `/campanhas/${id}/editar`;
/** Página pública de candidatura: sem login. */
export const CANDIDATURA_PAGE = (slug = ":slug") => `/candidatura/${slug}`;
/** Política de privacidade dos candidatos: pública (e a URL que a Meta exige no app). */
export const POLITICA_PRIVACIDADE_PAGE = () => "/politica-de-privacidade";
/** Criar com o assistente de IA. */
export const CAMPANHA_ASSISTENTE_PAGE = () => "/campanhas/assistente";
/** A próxima campanha, sugerida pela IA a partir dos resultados desta. */
export const CAMPANHA_PROXIMA_PAGE = (id = ":id") => `/campanhas/${id}/proxima`;
/** Criativos com a Eco-IA: biblioteca, criação e o estúdio de cada criativo. */
export const CRIATIVOS_PAGE = () => "/campanhas/criativos";
export const CRIATIVO_NOVO_PAGE = (campaignId?: string) => `/campanhas/criativos/novo${campaignId ? `?campanha=${campaignId}` : ""}`;
export const CRIATIVO_PAGE = (id = ":id") => `/campanhas/criativos/${id}`;
